import script from "./StagedBar.vue?vue&type=script&setup=true&lang=js"
export * from "./StagedBar.vue?vue&type=script&setup=true&lang=js"

import "./StagedBar.vue?vue&type=style&index=0&id=5c2b40b0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c2b40b0"]])

export default __exports__